module.exports = __webpack_public_path__ + "media/images/new_culture/bg-8-green-4a58fa7c42c81f6dc012ba6135b72299.png";